
import ToastAx   from 'app/actions/toast';
import CadminApi from 'app/apis/company-admin';
import CadminSlx from 'app/selectors/company-admin/';

const Types = {
  SEARCH: 'CADMIN_EMP_DONS_SEARCH',
  GET: 'CADMIN_EMP_DONS_GET',
  CHANGE_CAMPAIGN: 'CADMIN_EMP_DONS_CHANGE_CAMPAIGN',
  REPROCESS: 'CADMIN_EMP_DONS_REPROCESS',
};

const Actions = {

  search: (companyId, params) => {
    const promise = CadminApi.employeeDonationsSearch(companyId, params);
    return { type: Types.SEARCH, promise, _entities: ['campaigns', 'employeeDonations'] };
  },

  get: (companyId, edId) => (dispatch, getState) => {
    if (!companyId) companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.employeeDonationsGet(companyId, edId);
    return dispatch({type: Types.GET, promise, _entities: ['employeeDonation', 'campaign', 'employee', 'nonprofit'] });
  },

  changeCampaign: (edId, campaignId) => (dispatch, getState) => {
    const companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.employeeDonationsChangeCampaign(companyId, edId, campaignId);
    promise.then(() => {
      dispatch(ToastAx.success('Campaign successfully changed.'));
    }).catch((error) => {
      dispatch(ToastAx.error('Something went wrong while updating campaign.'));
    });
    return dispatch({type: Types.CHANGE_CAMPAIGN, promise, edId, _entities: ['employeeDonation', 'campaign', 'employee', 'nonprofit'] });
  },

  reprocess: (edId) => (dispatch, getState) => {
    const companyId = CadminSlx.companyId(getState());
    const promise = CadminApi.employeeDonationsReprocess(companyId, edId);
    promise.then(() => {
      dispatch(ToastAx.success('Match has been successfully reprocessed.'));
    }).catch((error) => {
      const isConflict = error.status === 409;
      const msg = isConflict ? 'This match has already been billed and can not be reprocessed.' : 'Something went wrong while trying to reprocess the match.';
      dispatch(ToastAx.error(msg));
    });
    return dispatch({type: Types.REPROCESS, promise, edId, _entities: ['employeeDonation', 'campaign', 'employee', 'nonprofit'] });
  },

};

export {
  Types,
};

export default Actions;
